import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TextView from "../../Components/UI/TextView/TextView";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CustomModal from "../../Components/CustomModal/CustomModal";
import {
  menuItemStyle,
  navBarCard,
  textfieldText,
} from "../../style/AppointmentStyle";
import ScienceTwoToneIcon from "@mui/icons-material/ScienceTwoTone";
import MedicalTests from "../../Components/ModalChildren/MedicalTests";
import HourglassEmptySharpIcon from "@mui/icons-material/HourglassEmptySharp";
import lab_tube from "../../assets/lab_tube.svg";
import UseGetLabTestCount from "../../helper/UseGetLabTestCount";
import { textfieldTextPrep } from "../../style/PatientDetailsStyle";
import SearchIcon from "@mui/icons-material/Search";
import DoneSharpIcon from "@mui/icons-material/DoneSharp";
import { setSearchPatient } from "../../redux/slices/prescriptionSlice";
import useDebounce from "../../hooks/UseDebounce";
import UseSearchPatient from "../../helper/UseSearchPatient";
import UseGetPatientPreviousReports from "../../helper/UseGetPatientPreviousReports";
import MergedReportsModal from "../../Components/ModalChildren/MergedReportsModal";
import { Menu as MenuIcon } from "@mui/icons-material";
import logo from "../../assets/logo_sq.svg";
import AddNewReport from "../../Components/ModalChildren/AddNewReport";
import useOrgName from "../../helper/useOrgName";

const LabNavbar = () => {
  const isMdUp = useMediaQuery("(min-width:750px)");
  const isCompact = useMediaQuery("(max-width: 1450px)");
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggleMobileMenu = () => setMobileOpen(!mobileOpen);
  const [openSearchDropDown, setOpenSearchDropDown] = useState(false);
  const [MedicalTest, setMedicalTest] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [inputValue, setInputValue] = useState("");
  const [openAddNewReport, setOpenAddNewReport] = useState(false);
  const [openMergedModal, setOpenMergedModal] = useState(false);
  const [addNeWReport, setAddNewReport] = useState({
    id: "",
    report: [],
    patient_info: {},
    refetch: false,
  });
  const [searchData, setSearchData] = useState({
    q: "",
    page: 1,
    perPage: 10,
  });
  // const [patientId, setPatientId] = useState(null);

  const { data: searchResult, isLoading: isSearchingPatient } =
    UseSearchPatient(searchData);
  // const { data: patientDetailsQuery } = UsePatientDetail(patientId);
  const { data: getPatientPrevReport, refetch: refetchGetPatientPrevReport } =
    UseGetPatientPreviousReports(addNeWReport?.id, "", "");

  const dispatch = useDispatch();

  const debouncedInputValue = useDebounce(inputValue, 1000);

  useEffect(() => {
    if (debouncedInputValue) {
      setSearchData((prev) => ({ ...prev, q: debouncedInputValue }));
    } else {
      dispatch(setSearchPatient([]));
    }
  }, [debouncedInputValue, dispatch]);

  useEffect(() => {
    if (searchResult?.payload?.patients) {
      dispatch(setSearchPatient(searchResult?.payload?.patients));
    }
  }, [searchResult, dispatch, inputValue]);

  // useEffect(() => {
  //     if (patientDetailsQuery?.payload) {
  //         dispatch(setPatientDetailsData(patientDetailsQuery.payload)); // Dispatch patient details to store
  //     }
  // }, [patientDetailsQuery, dispatch]);

  const authState = useSelector((state) => state.auth);
  const orgName = useOrgName();

  const { data: gitlabTestCount } = UseGetLabTestCount();
  // const { data: holidays } = UseFetchUpcomingholidays();

  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // change input for search
  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  useEffect(() => {
    const transformedData = getPatientPrevReport?.tests?.reduce((acc, obj) => {
      const dateKey = obj.created_date;

      // If the date already exists in the accumulator, push to the array
      if (acc[dateKey]) {
        acc[dateKey].push(obj);
      } else {
        // Otherwise, initialize with an array containing the first object
        acc[dateKey] = [obj];
      }

      return acc;
    }, {});
    setAddNewReport((prev) => ({
      ...prev,
      report: transformedData,
      patient_info: getPatientPrevReport?.patient_info,
    }));
    if (getPatientPrevReport?.tests) {
      setOpenAddNewReport(true);
    }
  }, [addNeWReport.id, getPatientPrevReport, addNeWReport?.refetch]);

  const { patientData } = useSelector((state) => state.prescription);

  const StatCard = ({ icon, title, value, bg, onClick }) => (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        p: "12px",
        borderRadius: "14px",
        border: "1px solid #E1E1E1",
        cursor: "pointer",
      }}
    >
      {/* ICON */}
      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: "10px",
          backgroundColor: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>

      {/* TEXT */}
      <Box display="flex" flexDirection="column">
        <TextView
          fontSize="13px"
          fontWeight={500} // ✅ increased
          sx={{ color: "#6c757d", mb: "4px" }} // ✅ 4px gap
        >
          {title}
        </TextView>

        <TextView fontSize="18px" fontWeight={600}>
          {value}
        </TextView>
      </Box>
    </Box>
  );

  const MobileBillingContent = ({ onClose }) => {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        {/* HEADER */}
        <TextView fontSize="18px" fontWeight={600}>
          Tests
        </TextView>

        {/* STATS */}
        <StatCard
          title="Medical Tests"
          bg="neutral.blueShadeBg"
          icon={
            <ScienceTwoToneIcon width={"22px"} sx={{ color: "neutral.teal" }} />
          }
          onClick={onClose}
        />

        <StatCard
          title="Total Tests"
          value={gitlabTestCount?.total_tests || 0}
          bg="#FFE7DC"
          icon={<img src={lab_tube} alt="" width={"28px"} />}
          onClick={onClose}
        />

        <StatCard
          title="In Process"
          value={gitlabTestCount?.pending_tests || 0}
          bg="#FEFF5C40"
          icon={
            <HourglassEmptySharpIcon sx={{ width: "28px", color: "#cccc00" }} />
          }
          onClick={onClose}
        />

        <StatCard
          title="Completed"
          value={gitlabTestCount?.done_tests || 0}
          bg="#EAF2F4"
          icon={<DoneSharpIcon sx={{ width: "28px", color: "#21C0A6" }} />}
          onClick={onClose}
        />
      </Box>
    );
  };

  return (
    <>
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 0,
          m: 0,
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          {/* /* MOBILE BURGER */}
          {!isMdUp && (
            <IconButton onClick={toggleMobileMenu}>
              <MenuIcon
                sx={{ color: "black", height: "1.5rem", width: "1.5rem" }}
              />
            </IconButton>
          )}

          {/* LEFT - LOGO */}
          <Box display="flex" alignItems="center">
            <img src={logo} alt="logo" style={{ width: "3.5rem" }} />
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: "black",
            justifyContent: "space-between",
            width: "100%",
            marginLeft: "2rem",
          }}
        >
          {isMdUp && (
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "2px",
                marginRight: 5,
              }}
            >
              {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "16PX",
                      paddingX: "15px",
                      paddingY: "15PX",
                      marginLeft: "8px",
                    }}
                    onClick={() => setOpenReport(true)}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#0067FF40",
                        width: "45px",
                        height: "45px",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img src={pending_reports} alt="" width={"22px"} />
                    </Box>
    
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <TextView
                        fontWeight={400}
                        fontSize={"14px"}
                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                      >
                        Pending
                      </TextView>
                      <TextView
                        fontSize={"20px"}
                        fontWeight={"600"}
                        variant={"h5"}
                        sx={{ mx: 2 }}
                      >
                        {getLabPendingReports?.meta?.total_count || 0}
                      </TextView>
                    </Box>
                  </Box> */}

              <Box sx={navBarCard} onClick={() => setMedicalTest(true)}>
                <Box
                  sx={{
                    backgroundColor: "neutral.blueShadeBg",
                    width: "45px",
                    height: "45px",
                    borderRadius: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ScienceTwoToneIcon
                    width={"22px"}
                    sx={{ color: "neutral.teal" }}
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <TextView
                    fontWeight={610}
                    fontSize={"16px"}
                    sx={{ mx: 2, color: "neutral.black", marginBottom: "3px" }}
                  >
                    Medical Tests
                  </TextView>
                  <TextView
                    fontSize={"20px"}
                    fontWeight={"600"}
                    variant={"h5"}
                    sx={{ mx: 2 }}
                  ></TextView>
                </Box>
              </Box>

              {isCompact ? (
                // Show merged card
                <Box sx={navBarCard}>
                  <Box
                    sx={{
                      backgroundColor: "#FFE7DC",
                      width: "45px",
                      height: "45px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img src={lab_tube} alt="" width={"28px"} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      cursor: "pointer",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <TextView
                      fontWeight={600}
                      fontSize={"15px"}
                      sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                    >
                      Total / In Process / Completed
                    </TextView>
                    <TextView
                      fontSize={"18px"}
                      fontWeight={"600"}
                      variant={"h5"}
                      sx={{ mx: 2 }}
                    >
                      {(gitlabTestCount?.total_tests || 0) +
                        " / " +
                        (gitlabTestCount?.pending_tests || 0) +
                        " / " +
                        (gitlabTestCount?.done_tests || 0)}
                    </TextView>
                  </Box>
                </Box>
              ) : (
                <>
                  <Box sx={navBarCard}>
                    <Box
                      sx={{
                        backgroundColor: "#FFE7DC",
                        width: "45px",
                        height: "45px",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img src={lab_tube} alt="" width={"28px"} />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <TextView
                        fontWeight={400}
                        fontSize={"14px"}
                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                      >
                        Total Tests
                      </TextView>
                      <TextView
                        fontSize={"20px"}
                        fontWeight={"600"}
                        variant={"h5"}
                        sx={{ mx: 2 }}
                      >
                        {gitlabTestCount?.total_tests || 0}
                      </TextView>
                    </Box>
                  </Box>

                  <Box sx={navBarCard}>
                    <Box
                      sx={{
                        backgroundColor: "#FEFF5C40",
                        width: "45px",
                        height: "45px",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <HourglassEmptySharpIcon
                        sx={{ width: "28px", color: "#cccc00" }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <TextView
                        fontWeight={400}
                        fontSize={"14px"}
                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                      >
                        In Process
                      </TextView>
                      <TextView
                        fontSize={"20px"}
                        fontWeight={"600"}
                        variant={"h5"}
                        sx={{ mx: 2 }}
                      >
                        {gitlabTestCount?.pending_tests || 0}
                      </TextView>
                    </Box>
                  </Box>

                  <Box sx={navBarCard}>
                    <Box
                      sx={{
                        backgroundColor: "#EAF2F4",
                        width: "45px",
                        height: "45px",
                        borderRadius: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <DoneSharpIcon sx={{ width: "28px", color: "#21C0A6" }} />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <TextView
                        fontWeight={400}
                        fontSize={"14px"}
                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                      >
                        Completed
                      </TextView>
                      <TextView
                        fontSize={"20px"}
                        fontWeight={"600"}
                        variant={"h5"}
                        sx={{ mx: 2 }}
                      >
                        {gitlabTestCount?.done_tests || 0}
                      </TextView>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              minWidth: "100px",
            }}
          >
            <Box width={"100%"}>
              <Autocomplete
                popupIcon={false}
                open={Boolean(patientData?.length) && openSearchDropDown}
                clearIcon={false}
                clearOnBlur={false}
                onOpen={() => setOpenSearchDropDown(true)}
                noOptionsText={""}
                onClose={() => {
                  dispatch(setSearchPatient([]));
                  setOpenSearchDropDown(false);
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setAddNewReport(() => ({
                      id: newValue?.id,
                      report: [],
                      refetch: !addNeWReport?.refetch,
                    }));

                    setInputValue("");
                  }
                }}
                filterOptions={(options) => options}
                onInputChange={handleInputChange}
                options={patientData || []}
                getOptionLabel={(option) =>
                  option.uid && option.full_name
                    ? `${option.uid} - ${option.full_name}`
                    : ""
                }
                renderOption={(props, option) => (
                  <MenuItem
                    key={option.id + Math.random()}
                    // onClick={() => selectedPatient(option)}
                    {...props}
                    sx={{
                      ...menuItemStyle,
                    }}
                  >{`${option.uid} - ${option.full_name}`}</MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    id="search"
                    placeholder="Search Patient"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {isSearchingPatient ? (
                            <CircularProgress size={18} sx={{ mr: 1 }} />
                          ) : (
                            <SearchIcon sx={{ opacity: 0.4, mr: 1 }} />
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    sx={textfieldText}
                  />
                )}
              />
            </Box>
          </Box>
        </Box>

        <Box>
          <IconButton onClick={handleMenuOpen} color="black">
            <AccountCircleIcon
              sx={{ height: "3.6rem", width: "3rem", color: "black" }}
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              marginLeft: "2.5rem",
              marginTop: "-0.5rem",
              "& .MuiPaper-root": {
                borderRadius: "12px",
                // padding: "16px",
                minWidth: "180px",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "3px",
                p: 2,
              }}
            >
              {orgName && (
                <Box
                  sx={{
                    fontFamily: "Lato",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    marginBottom: "2px",
                    color: "neutral.navyBlue",
                  }}
                >
                  {orgName}
                </Box>
              )}
              <Box sx={{ fontFamily: "Outfit" }}> {authState?.first_name} </Box>
              <Box
                sx={{
                  fontWeight: "bold",
                  fontFamily: "sans-serif",
                  fontSize: "1rem",
                }}
              >
                {authState?.user}
              </Box>

              <Box sx={{ marginTop: "5px", fontSize: "0.87rem" }}>
                {authState?.email}
              </Box>

              <Button
                //  style={{border :'2px solid black'}}
                disableRipple
                startIcon={
                  <LogoutOutlinedIcon
                    sx={{
                      borderRadius: "50%",
                      padding: "8px",
                      color: "neutral.navyBlue",
                      "&:hover": {
                        // backgroundColor: "neutral.navyBlue",
                        color: "white",
                      },
                    }}
                  />
                }
                sx={{
                  backgroundColor: "neutral.blueShadeBg",
                  marginTop: "0.5rem",
                  color: "grey",
                  "&:hover": {
                    backgroundColor: "neutral.blueShadeBg",
                    color: "gray",
                    "& .MuiSvgIcon-root": {
                      backgroundColor: "neutral.teal",
                      color: "white",
                    },
                  },
                  borderRadius: "14px",
                  textTransform: "capitalize",
                  width: "100%",
                  justifyContent: "flex-start",
                  fontSize: "16px",
                }}
                onClick={handleLogout}
              >
                Logout
              </Button>
            </Box>
          </Menu>
        </Box>
      </Toolbar>

      {/* MOBILE DRAWER */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleMobileMenu}>
        <Box width={300} p={2}>
          <MobileBillingContent onClose={toggleMobileMenu} />
        </Box>
      </Drawer>

      <CustomModal
        customStyles={{
          border: "none",
          width: "90%",
          backgroundColor: "neutral.blueShadeBg",
        }}
        open={MedicalTest}
        onClose={() => setMedicalTest(false)}
      >
        <MedicalTests onClose={() => setMedicalTest(false)} />
      </CustomModal>
      <CustomModal
        open={openAddNewReport}
        onClose={() => setOpenAddNewReport(false)}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 1,
            px: 1,
          }}
        >
          <Button
            variant="text"
            size="small"
            onClick={() => {
              setOpenAddNewReport(false);
              setOpenMergedModal(true);
            }}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              color: "neutral.teal",
              fontSize: "13px",
              p: 0,
              minWidth: "auto",
              "&:hover": { background: "none", textDecoration: "underline" },
            }}
          >
            View New Design →
          </Button>
        </Box>
        <AddNewReport
          patientData={addNeWReport?.patient_info}
          onClose={() => setOpenAddNewReport(false)}
          report={addNeWReport?.report}
          refetchGetPatientPrevReport={refetchGetPatientPrevReport}
          handlePreview={refetchGetPatientPrevReport}
          patient_id={addNeWReport?.id}
        />
      </CustomModal>
      <CustomModal
        open={openMergedModal}
        onClose={() => setOpenMergedModal(false)}
      >
        <MergedReportsModal
          patientData={addNeWReport?.patient_info}
          onClose={() => setOpenMergedModal(false)}
          report={addNeWReport?.report}
          refetchGetPatientPrevReport={refetchGetPatientPrevReport}
          handlePreview={refetchGetPatientPrevReport}
          patient_id={addNeWReport?.id}
        />
      </CustomModal>
    </>
  );
};

export default LabNavbar;
